import React from 'react';

function MetricCard({ label, value, unit, highlight = false }) {
  const displayValue = value ?? '—';

  return (
    <div className={`metric-card${highlight ? ' metric-card-highlight' : ''}`}>
      <span className="metric-card-label">{label}</span>
      <div>
        <span className="metric-card-value">{displayValue}</span>
        {unit && displayValue !== '—' && (
          <span className="metric-card-unit">{unit}</span>
        )}
      </div>
    </div>
  );
}

export default MetricCard;
